/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
const ADMIN_PASS  = "admin123";
const EMP_PASS    = "sendo123";

const VEHICLES = [
  "KA01AE8482","KA01AF8611","KA01AM6327","KA01AM6328","KA01AM6329","KA01AM6330",
  "KA01AM6331","KA01AR0996","KA01AR0997","KA02C6247","KA03AH4987","KA04AC1128",
  "KA04AC1182","KA06AA0880","KA09C1390","KA20A6593","KA20D0564","KA41D4863",
  "KA51AC8745","KA51AG7183","KA51AH5365","KA51AH5366","KA51AH5457","KA51AH8375",
  "KA51AH8379","KA51AJ4011","KA51AK4010","KA51AK4936","KA51AK4937","KA51AK4938",
  "KA51AK4939","KA51AK4940","KA51AK4941","KA51AK4942","KA51AK4943","KA51AK4944",
  "KA51AK4945","KA51AL7240","KA51AL7241","KA51AL7242","KA51AL7243","KA51AL7244",
  "KA51AM2815","KA53A7588","NEW 17FT","NEW 20FT","NEW 20FT 8416","NEW VEHICLE"
];
const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const MONTHS_FULL  = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const VTYPES       = ['','Pickup Truck','407 Truck','17FT','20FT'];
const YEARS        = ['2024','2025','2026','2027'];

// Hook for responsive detection
function useMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return isMobile;
}

// Build style tokens — reactive to mobile
function makeS(isMobile) {
  return {
    page:      { marginLeft: isMobile ? 0 : 260, marginRight: 0, fontFamily:'Arial,sans-serif', backgroundColor:'#fff', color:'#000', minHeight:'calc(100vh - 70px)', boxShadow:'0 2px 8px rgba(0,0,0,.08)' },
    heading:   { background:'#FFC107', color:'#000', padding: isMobile ? '12px 14px' : '14px 24px', fontSize: isMobile ? '0.95rem' : '1.05rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:1, margin:0 },
    tabRow:    { display:'flex', gap:0, borderBottom:'2px solid #e0e0e0', background:'#fafafa', flexWrap:'wrap', overflowX: isMobile ? 'auto' : 'visible', WebkitOverflowScrolling:'touch' },
    tab:       (active) => ({ padding: isMobile ? '9px 12px' : '11px 20px', fontWeight:active?'bold':'normal', fontSize: isMobile ? 12 : 13, border:'none', borderBottom:active?'2px solid #FFC107':'2px solid transparent', background:active?'#fff':'transparent', color:active?'#000':'#666', cursor:'pointer', marginBottom:-2, whiteSpace:'nowrap' }),
    body:      { padding: isMobile ? '12px' : 20 },
    card:      { background:'#fff', border:'1.5px solid #000', borderRadius:4, padding: isMobile ? '12px' : '16px 18px', marginBottom:14 },
    cardTitle: { fontWeight:'bold', fontSize:14, marginBottom:10, color:'#000' },
    subTitle:  { fontSize:13, color:'#555', marginBottom:14 },
    grid2:     { display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2,1fr)', gap:12, marginBottom:12 },
    grid1:     { display:'grid', gridTemplateColumns:'1fr', gap:12, marginBottom:12 },
    lbl:       { fontSize:11, fontWeight:'bold', color:'#000', marginBottom:4, display:'block' },
    input:     { padding:'8px 10px', border:'1.5px solid #000', borderRadius:3, fontSize: isMobile ? 14 : 13, width:'100%', boxSizing:'border-box', fontFamily:'Arial,sans-serif', color:'#000', background:'#fff' },
    select:    { padding:'8px 10px', border:'1.5px solid #000', borderRadius:3, fontSize: isMobile ? 14 : 13, background:'#fff', width:'100%', boxSizing:'border-box', color:'#000' },
    btnYellow: { background:'#FFC107', color:'#000', border:'1.5px solid #FFC107', padding: isMobile ? '8px 14px' : '9px 20px', borderRadius:3, cursor:'pointer', fontWeight:'bold', fontSize: isMobile ? 12 : 13, fontFamily:'Arial,sans-serif' },
    btnBlack:  { background:'#000', color:'#fff', border:'1.5px solid #000', padding: isMobile ? '8px 14px' : '9px 20px', borderRadius:3, cursor:'pointer', fontWeight:'bold', fontSize: isMobile ? 12 : 13, fontFamily:'Arial,sans-serif' },
    btnWhite:  { background:'#fff', color:'#000', border:'1.5px solid #000', padding: isMobile ? '8px 14px' : '9px 20px', borderRadius:3, cursor:'pointer', fontWeight:'bold', fontSize: isMobile ? 12 : 13, fontFamily:'Arial,sans-serif' },
    btnOutline:(color) => ({ background:'transparent', border:`1.5px solid ${color}`, color, padding:'7px 14px', borderRadius:3, cursor:'pointer', fontSize:12, fontWeight:'bold' }),
    success:   { background:'#f0fff4', border:'1.5px solid #000', color:'#000', padding:'10px 14px', borderRadius:3, fontSize:13, marginTop:10 },
    error:     { background:'#fff0f0', border:'1.5px solid #000', color:'#000', padding:'10px 14px', borderRadius:3, fontSize:13, marginTop:10 },
    info:      { background:'#fffde7', border:'1.5px solid #FFC107', borderRadius:3, padding:'10px 14px', fontSize:13, color:'#000', marginBottom:12 },
    amber:     { background:'#fffde7', border:'1.5px solid #FFC107', borderRadius:3, padding:'10px 14px', fontSize:13, color:'#000', marginBottom:12 },
    th:        { background:'#000', color:'#fff', padding: isMobile ? '8px 6px' : '11px 10px', textAlign:'center', fontSize: isMobile ? 10 : 12, fontWeight:'bold', whiteSpace:'nowrap' },
    td:        { border:'1px solid #e0e0e0', padding: isMobile ? '7px 6px' : '9px 10px', textAlign:'center', fontSize: isMobile ? 11 : 12, color:'#000' },
    code:      { background:'#f5f5f5', border:'1px solid #ccc', borderRadius:3, padding:'2px 8px', fontFamily:'monospace', fontSize:13, color:'#000' },
    tableWrap: { overflowX:'auto', WebkitOverflowScrolling:'touch', width:'100%' },
    toolBar:   { display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', marginBottom:12 },
  };
}

export default function AdminPanel() {
  const isMobile = useMobile();
  const S = makeS(isMobile);
  const [mainTab, setMainTab] = useState('datamanage');

  return (
    <div style={S.page}>
      <h2 style={S.heading}>Admin Panel</h2>

      {/* Main tabs — scroll horizontally on mobile */}
      <div style={S.tabRow}>
        {[
          { id:'datamanage',   label: isMobile ? 'Data' : 'Data Management' },
          { id:'escalations',  label:'Escalations' },
          { id:'vperf',        label: isMobile ? 'Performance' : 'Vehicle Performance' },
        ].map(t => (
          <button key={t.id} style={S.tab(mainTab===t.id)} onClick={()=>setMainTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={S.body}>
        {mainTab === 'datamanage'  && <DataManagement S={S} isMobile={isMobile} />}
        {mainTab === 'escalations' && <Escalations    S={S} isMobile={isMobile} />}
        {mainTab === 'vperf'       && <VehiclePerformance S={S} isMobile={isMobile} />}
      </div>
    </div>
  );
}

// DATA MANAGEMENT
function DataManagement({ S, isMobile }) {
  const [sub, setSub] = useState('entry');

  return (
    <>
      {/* Sub-tabs — scrollable on mobile */}
      <div style={{ ...S.tabRow, marginBottom:20, borderRadius:3, overflow:'hidden' }}>
        {[
          { id:'entry',     label: isMobile ? 'Add' : 'Add Entry' },
          { id:'migration', label: isMobile ? 'Migrate' : 'Data Migration' },
          { id:'schedule',  label:'Schedule' },
          { id:'employees', label:'Employees' },
        ].map(t => (
          <button key={t.id} style={{ ...S.tab(sub===t.id), flex:1, textAlign:'center' }} onClick={()=>setSub(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      {sub === 'entry'     && <AddEntry     S={S} isMobile={isMobile} />}
      {sub === 'migration' && <DataMigration S={S} isMobile={isMobile} />}
      {sub === 'schedule'  && <ScheduleConfig S={S} isMobile={isMobile} />}
      {sub === 'employees' && <Employees S={S} isMobile={isMobile} />}
    </>
  );
}

// ADD ENTRY
function AddEntry({ S, isMobile }) {
  const now   = new Date();
  const aMon  = MONTHS_SHORT[now.getMonth()];
  const aYr   = String(now.getFullYear());
  const days  = Array.from({ length: new Date(parseInt(aYr), MONTHS_SHORT.indexOf(aMon)+1, 0).getDate() }, (_,i) =>
    `${String(i+1).padStart(2,'0')}-${aMon}`);

  const INIT = { vehicle:'', vtype:'', date:'', litres:'', amount:'', driver:'', paid:'', time:'', odo:'' };
  const [form,    setForm]    = useState(INIT);
  const [entries, setEntries] = useState([]);
  const [msg,     setMsg]     = useState({ type:'', text:'' });
  const [xlStatus,setXlStatus]= useState('');
  const fileRef = useRef();

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.vehicle) return showMsg('error','Select a vehicle');
    if (!form.date)    return showMsg('error','Select a date');
    if (!form.litres || parseFloat(form.litres)<=0) return showMsg('error','Enter litres');
    if (!form.amount || parseFloat(form.amount)<=0) return showMsg('error','Enter amount');
    if (!form.driver)  return showMsg('error','Enter driver name');

    const timeStr = form.time ? (() => {
      const [h,m] = form.time.split(':').map(Number);
      return `${h%12||12}:${String(m).padStart(2,'0')} ${h>=12?'PM':'AM'}`;
    })() : '';

    try {
      await axios.post(`${API_BASE_URL}/api/fills`, {
        vehicle: form.vehicle, date: form.date,
        month: `${aMon}-${aYr}`, year: aYr,
        driver: form.driver.toUpperCase(),
        paidBy: form.paid.toUpperCase(),
        litres: parseFloat(form.litres),
        amount: parseInt(form.amount),
        time:   timeStr,
        vtype:  form.vtype,
      });
      setEntries(prev => [{ ...form, timeStr, id: Date.now() }, ...prev]);
      showMsg('success', `Saved: ${form.vehicle} — ${form.date} — ${form.litres}L — Rs.${form.amount} — ${form.driver}`);
      setForm(INIT);
    } catch(e) {
      showMsg('error', `Save failed: ${e.response?.data?.message || e.message}`);
    }
  };

  const showMsg = (type, text) => {
    setMsg({ type, text });
    setTimeout(() => setMsg({ type:'', text:'' }), 4000);
  };

  const handleExcelImport = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setXlStatus('Reading Excel file...');
    try {
      if (!window.XLSX) {
        await new Promise((res, rej) => {
          const s = document.createElement('script');
          s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
          s.onload = res; s.onerror = rej; document.head.appendChild(s);
        });
      }
      const buf = await file.arrayBuffer();
      const wb  = window.XLSX.read(buf, { type:'array', cellDates:true });
      const dieselSheet = wb.SheetNames.find(n => n.toUpperCase().includes('DIESEL'));
      if (!dieselSheet) { setXlStatus('DIESEL sheet not found'); return; }

      const rows = window.XLSX.utils.sheet_to_json(wb.Sheets[dieselSheet], { raw:false, dateNF:'DD-MMM-YYYY' });
      setXlStatus(`Found ${rows.length} rows — parsing...`);

      const parsedData = {};
      for (const row of rows) {
        const veh    = (row['VEHICLE NUMBER'] || row['Vehicle Number'] || '').toString().trim().toUpperCase();
        const dateRaw= row['Transaction Date'] || row['Date'] || '';
        const driver = (row['DRIVER NAME'] || row['Driver'] || '').toString().trim().toUpperCase();
        const paidBy = (row['Name of Card']  || row['Paid By'] || '').toString().trim().toUpperCase();
        const litres = parseFloat(row['Volume (Litres)'] || row['Litres'] || 0);
        const amount = parseInt(row['Purchase Amount']   || row['Amount'] || 0);
        if (!veh || !dateRaw || !litres) continue;

        try {
          const dt  = new Date(dateRaw);
          if (isNaN(dt)) continue;
          const dd  = String(dt.getDate()).padStart(2,'0');
          const mon = MONTHS_SHORT[dt.getMonth()];
          const yr  = dt.getFullYear();
          const dateStr  = `${dd}-${mon}`;
          const monthKey = `${mon}-${yr}`;
          if (!parsedData[monthKey]) parsedData[monthKey] = {};
          if (!parsedData[monthKey][veh]) parsedData[monthKey][veh] = {};
          const ex = parsedData[monthKey][veh][dateStr];
          if (!ex) {
            parsedData[monthKey][veh][dateStr] = { l:litres, a:amount, d:driver, p:paidBy };
          } else {
            if (!ex.fills) ex.fills = [{ l:ex.l, a:ex.a, d:ex.d, p:ex.p }];
            ex.fills.push({ l:litres, a:amount, d:driver, p:paidBy });
            ex.l += litres; ex.a += amount;
          }
        } catch { continue; }
      }

      const detected = Object.keys(parsedData);
      if (!detected.length) { setXlStatus('No valid data found'); return; }

      for (const mk of detected) {
        await axios.post(`${API_BASE_URL}/api/fills/bulk`, { month:mk, data:parsedData[mk] });
      }
      setXlStatus(`Imported ${rows.length} rows for ${detected.join(', ')}`);
    } catch(err) {
      setXlStatus(`Error: ${err.message}`);
    }
    e.target.value = '';
  };

  return (
    <div style={{ maxWidth:700 }}>
      {/* Excel Import */}
      <div style={S.card}>
        <div style={S.cardTitle}>Import Excel Data</div>
        <p style={{ color:'#555', fontSize:13, marginBottom:12 }}>
          Upload your monthly Excel file (DIESEL sheet). Automatically detects the month.
        </p>
        <input ref={fileRef} type="file" accept=".xlsx,.xls" style={{ display:'none' }} onChange={handleExcelImport} />
        <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', marginBottom:10 }}>
          <button style={S.btnYellow} onClick={()=>fileRef.current.click()}>Choose Excel File</button>
          <span style={{ fontSize:12, color:'#666' }}>Supports .xlsx with DIESEL sheet</span>
        </div>
        {xlStatus && <div style={{ fontSize:13, color:'#000', fontFamily:'monospace', marginTop:6 }}>{xlStatus}</div>}
        <div style={{ ...S.amber, marginTop:10 }}>
          Google Sheets sync: Not configured yet.
        </div>
      </div>

      {/* Manual Entry */}
      <div style={S.card}>
        <div style={S.cardTitle}>Manual Entry</div>

        <div style={S.grid2}>
          <div>
            <label style={S.lbl}>Vehicle Number</label>
            <select style={S.select} value={form.vehicle} onChange={e=>set('vehicle',e.target.value)}>
              <option value="">Select Vehicle</option>
              {VEHICLES.map(v=><option key={v}>{v}</option>)}
            </select>
          </div>
          <div>
            <label style={S.lbl}>Vehicle Type</label>
            <select style={S.select} value={form.vtype} onChange={e=>set('vtype',e.target.value)}>
              {VTYPES.map(t=><option key={t} value={t}>{t||'Select Type'}</option>)}
            </select>
          </div>
        </div>

        <div style={S.grid2}>
          <div>
            <label style={S.lbl}>Date</label>
            <select style={S.select} value={form.date} onChange={e=>set('date',e.target.value)}>
              <option value="">Select Date</option>
              {days.map(d=><option key={d}>{d}</option>)}
            </select>
          </div>
        </div>

        <div style={S.grid2}>
          <div>
            <label style={S.lbl}>Litres</label>
            <input style={S.input} type="number" step="0.1" min="0" placeholder="e.g. 45.5"
              value={form.litres} onChange={e=>set('litres',e.target.value)} />
          </div>
          <div>
            <label style={S.lbl}>Amount</label>
            <input style={S.input} type="number" min="0" placeholder="e.g. 4076"
              value={form.amount} onChange={e=>set('amount',e.target.value)} />
          </div>
        </div>

        <div style={S.grid2}>
          <div>
            <label style={S.lbl}>Driver Name</label>
            <input style={S.input} placeholder="Driver name..."
              value={form.driver} onChange={e=>set('driver',e.target.value.toUpperCase())} />
          </div>
          <div>
            <label style={S.lbl}>Paid By</label>
            <input style={S.input} placeholder="Paid by..."
              value={form.paid} onChange={e=>set('paid',e.target.value.toUpperCase())} />
          </div>
        </div>

        <div style={S.grid2}>
          <div>
            <label style={S.lbl}>Fill Time</label>
            <input style={S.input} type="time" step="60" value={form.time} onChange={e=>set('time',e.target.value)} />
          </div>
          <div>
            <label style={S.lbl}>Odometer (KM) <span style={{ color:'#666', fontWeight:400, fontSize:11 }}>optional</span></label>
            <input style={S.input} type="number" min="0" placeholder="e.g. 45200"
              value={form.odo} onChange={e=>set('odo',e.target.value)} />
          </div>
        </div>

        <div style={{ display:'flex', gap:10 }}>
          <button style={S.btnYellow} onClick={handleSubmit}>Save Entry</button>
          <button style={S.btnBlack}  onClick={()=>{ setForm(INIT); setMsg({type:'',text:''}); }}>Clear</button>
        </div>

        {msg.text && <div style={msg.type==='success'?S.success:S.error}>{msg.text}</div>}
      </div>

      {/* Recent Entries */}
      <div style={{ border:'1.5px solid #000', borderRadius:4, overflow:'hidden' }}>
        <div style={{ padding:'10px 14px', fontWeight:'bold', fontSize:13, borderBottom:'1px solid #e0e0e0', background:'#fafafa' }}>
          Recent Entries (This Session)
        </div>
        <div style={S.tableWrap}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr>
                {['Vehicle','Date','Driver','Paid By','Litres','Amount',''].map(h=>(
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {entries.length===0 ? (
                <tr><td colSpan={7} style={{ ...S.td, color:'#aaa', padding:24, textAlign:'center' }}>No entries added yet</td></tr>
              ) : entries.map((e,i)=>(
                <tr key={e.id} style={{ background: i%2===0?'#fff':'#fafafa' }}>
                  <td style={{ ...S.td, fontFamily:'monospace', fontWeight:700 }}>{e.vehicle}</td>
                  <td style={S.td}>{e.date}</td>
                  <td style={S.td}>{e.driver}</td>
                  <td style={S.td}>{e.paid||'—'}</td>
                  <td style={{ ...S.td, fontWeight:700 }}>{e.litres}L</td>
                  <td style={S.td}>Rs.{parseInt(e.amount).toLocaleString()}</td>
                  <td style={S.td}>
                    <button style={{ background:'none', border:'none', color:'#ccc', cursor:'pointer', fontSize:13 }}
                      onMouseEnter={e2=>e2.target.style.color='#c00'}
                      onMouseLeave={e2=>e2.target.style.color='#ccc'}
                      onClick={()=>setEntries(prev=>prev.filter((_,idx)=>idx!==i))}>x</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// DATA MIGRATION
function DataMigration({ S, isMobile }) {
  const [syncMsg,       setSyncMsg]       = useState('');
  const [jsonImportMsg, setJsonImportMsg] = useState('');
  const jsonRef = useRef();
  const showSync = (msg, ok=true) => setSyncMsg({ msg, ok });

  const syncAll = async () => {
    showSync('Syncing all data...');
    try {
      const cfg = JSON.parse(localStorage.getItem('fleetScheduleConfig')||'{}');
      await axios.post(`${API_BASE_URL}/api/schedule/bulk`, { configs: cfg });
      const escs = JSON.parse(localStorage.getItem('fleetEscalations')||'[]');
      if (escs.length) await axios.post(`${API_BASE_URL}/api/escalations/bulk`, { escalations: escs });
      showSync('All synced successfully.');
    } catch(e) { showSync(`Sync failed: ${e.message}`, false); }
    setTimeout(()=>setSyncMsg(''), 4000);
  };

  const syncSchedule = async () => {
    showSync('Syncing schedule...');
    try {
      const cfg = JSON.parse(localStorage.getItem('fleetScheduleConfig')||'{}');
      await axios.post(`${API_BASE_URL}/api/schedule/bulk`, { configs: cfg });
      showSync('Schedule synced.');
    } catch(e) { showSync(`Failed: ${e.message}`, false); }
    setTimeout(()=>setSyncMsg(''), 4000);
  };

  const syncEscalations = async () => {
    showSync('Syncing escalations...');
    try {
      const escs = JSON.parse(localStorage.getItem('fleetEscalations')||'[]');
      await axios.post(`${API_BASE_URL}/api/escalations/bulk`, { escalations: escs });
      showSync(`${escs.length} escalations synced.`);
    } catch(e) { showSync(`Failed: ${e.message}`, false); }
    setTimeout(()=>setSyncMsg(''), 4000);
  };

  const exportJSON = async () => {
    try {
      const [fills, sched, escs] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/fills/all`).then(r=>r.data?.data||{}).catch(()=>{}),
        axios.get(`${API_BASE_URL}/api/schedule`).then(r=>r.data?.data||{}).catch(()=>{}),
        axios.get(`${API_BASE_URL}/api/escalations`).then(r=>r.data?.data||[]).catch(()=>[]),
      ]);
      const backup = { ALL_MONTHS_DATA:fills||{}, scheduleConfig:sched||{}, ESCALATIONS:escs||[] };
      const blob = new Blob([JSON.stringify(backup, null, 2)], { type:'application/json' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `sendo_fleet_backup_${new Date().toISOString().slice(0,10)}.json`;
      a.click();
    } catch { alert('Export failed — check backend'); }
  };

  const exportExcel = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/fills/all`);
      const allData = res.data?.data || {};
      const rows = [];
      Object.entries(allData).forEach(([monthKey, mData]) => {
        Object.entries(mData).forEach(([v, vd]) => {
          Object.entries(vd).forEach(([date, info]) => {
            rows.push({ Month:monthKey, Vehicle:v, Date:date, Driver:info.d||'', PaidBy:info.p||'', Litres:info.l||0, Amount:info.a||0, Time:info.t||'', PayType:info.payType||'', Station:info.station||'' });
          });
        });
      });
      await loadXLSX();
      const ws = window.XLSX.utils.json_to_sheet(rows);
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, 'Fleet Data');
      window.XLSX.writeFile(wb, `sendo_export_${new Date().toISOString().slice(0,10)}.xlsx`);
    } catch { alert('Export failed'); }
  };

  const exportExcelOdo = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/fills/all`);
      const allData = res.data?.data || {};
      const rows = [];
      Object.entries(allData).forEach(([monthKey, mData]) => {
        Object.entries(mData).forEach(([v, vd]) => {
          Object.entries(vd).forEach(([date, info]) => {
            rows.push({ Month:monthKey, Vehicle:v, Date:date, Driver:info.d||'', Litres:info.l||0, Amount:info.a||0, OpeningKM:'', ClosingKM:'', TotalKM:'' });
          });
        });
      });
      await loadXLSX();
      const ws = window.XLSX.utils.json_to_sheet(rows);
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, 'Fleet+Odometer');
      window.XLSX.writeFile(wb, `sendo_with_odo_${new Date().toISOString().slice(0,10)}.xlsx`);
    } catch { alert('Export failed'); }
  };

  const exportCSV = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/fills/all`);
      const allData = res.data?.data || {};
      const rows = ['Month,Vehicle,Date,Driver,PaidBy,Litres,Amount'];
      Object.entries(allData).forEach(([monthKey, mData]) => {
        Object.entries(mData).forEach(([v, vd]) => {
          Object.entries(vd).forEach(([date, info]) => {
            rows.push(`${monthKey},${v},${date},${info.d||''},${info.p||''},${info.l||0},${info.a||0}`);
          });
        });
      });
      const blob = new Blob([rows.join('\n')], { type:'text/csv' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
      a.download = `sendo_export_${new Date().toISOString().slice(0,10)}.csv`; a.click();
    } catch { alert('Export failed'); }
  };

  const handleJSONImport = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const data = JSON.parse(ev.target.result);
        if (data.scheduleConfig) {
          localStorage.setItem('fleetScheduleConfig', JSON.stringify(data.scheduleConfig));
          await axios.post(`${API_BASE_URL}/api/schedule/bulk`, { configs: data.scheduleConfig }).catch(()=>{});
        }
        if (data.ESCALATIONS) {
          localStorage.setItem('fleetEscalations', JSON.stringify(data.ESCALATIONS));
        }
        if (data.ALL_MONTHS_DATA) {
          for (const [mk, mData] of Object.entries(data.ALL_MONTHS_DATA)) {
            await axios.post(`${API_BASE_URL}/api/fills/bulk`, { month:mk, data:mData }).catch(()=>{});
          }
        }
        setJsonImportMsg({ type:'success', text:'Import successful. Data merged.' });
      } catch(err) {
        setJsonImportMsg({ type:'error', text:`Invalid JSON: ${err.message}` });
      }
    };
    reader.readAsText(file);
    e.target.value = '';
    setTimeout(()=>setJsonImportMsg({}), 5000);
  };

  return (
    <div style={{ maxWidth:700 }}>
      {/* Sync Card */}
      <div style={S.card}>
        <div style={S.cardTitle}>Sync to MongoDB</div>
        <div style={S.subTitle}>Push all local data to MongoDB — Fuel Fills, Schedule Config, Escalations</div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:10 }}>
          <button style={S.btnYellow} onClick={syncAll}>Sync All to MongoDB</button>
          <button style={S.btnWhite}  onClick={syncSchedule}>Schedule Config</button>
          <button style={S.btnWhite}  onClick={syncEscalations}>Escalations</button>
        </div>
        {syncMsg && <div style={{ fontSize:12, fontFamily:'monospace', color:'#000', marginTop:6 }}>{syncMsg.msg}</div>}
      </div>

      {/* Export Card */}
      <div style={S.card}>
        <div style={S.cardTitle}>Export Data</div>
        <p style={S.subTitle}>Download all fleet data as JSON backup or Excel for sharing.</p>
        <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
          <button style={S.btnYellow} onClick={exportJSON}>Export JSON Backup</button>
          <button style={S.btnWhite}  onClick={exportExcel}>Export Excel</button>
          <button style={S.btnWhite}  onClick={exportExcelOdo}>Export with Odometer</button>
          <button style={S.btnWhite}  onClick={exportCSV}>Export CSV</button>
        </div>
      </div>

      {/* Import Card */}
      <div style={S.card}>
        <div style={S.cardTitle}>Import JSON Backup</div>
        <p style={{ ...S.subTitle, marginBottom:14 }}>
          Restore a previously exported JSON backup. This will <strong>merge</strong> with existing data.
        </p>
        <input ref={jsonRef} type="file" accept=".json" style={{ display:'none' }} onChange={handleJSONImport} />
        <button style={S.btnYellow} onClick={()=>jsonRef.current.click()}>
          Choose JSON Backup
        </button>
        {jsonImportMsg?.text && <div style={jsonImportMsg.type==='success'?S.success:S.error}>{jsonImportMsg.text}</div>}
      </div>
    </div>
  );
}

async function loadXLSX() {
  if (typeof window.XLSX !== 'undefined') return;
  return new Promise((res,rej)=>{
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
    s.onload = res; s.onerror = rej; document.head.appendChild(s);
  });
}

// SCHEDULE CONFIG
function ScheduleConfig({ S, isMobile }) {
  const [rows,   setRows]   = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('fleetScheduleConfig')||'{}');
      return VEHICLES.map(v => ({ vehicle:v, interval:saved[v]?.interval||'', ltrs:saved[v]?.ltrsPerFill||'', kml:saved[v]?.kmPerLitre||'', expKm:saved[v]?.kmPerFill||'', actKm:saved[v]?.kmActual||'', vtype:saved[v]?.vehicleType||'' }));
    } catch { return VEHICLES.map(v => ({ vehicle:v, interval:'', ltrs:'', kml:'', expKm:'', actKm:'', vtype:'' })); }
  });
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/schedule`).then(res => {
      const cfg = res.data?.data || {};
      setRows(prev => prev.map(r => ({ ...r, ...(cfg[r.vehicle] ? {
        interval: cfg[r.vehicle].interval||'', ltrs: cfg[r.vehicle].ltrsPerFill||'',
        kml: cfg[r.vehicle].kmPerLitre||'', expKm: cfg[r.vehicle].kmPerFill||'',
        actKm: cfg[r.vehicle].kmActual||'', vtype: cfg[r.vehicle].vehicleType||'',
      } : {}) })));
    }).catch(()=>{});
  }, []);

  const change = (v, field, val) => setRows(prev => prev.map(r => r.vehicle===v ? {...r,[field]:val} : r));

  const saveAll = async () => {
    const cfg = {};
    rows.forEach(r => {
      if (r.interval||r.ltrs||r.kml||r.expKm||r.actKm||r.vtype) {
        cfg[r.vehicle] = { interval:parseInt(r.interval)||null, ltrsPerFill:parseFloat(r.ltrs)||null, kmPerLitre:parseFloat(r.kml)||null, kmPerFill:parseInt(r.expKm)||(r.ltrs&&r.kml?Math.round(parseFloat(r.ltrs)*parseFloat(r.kml)):null)||null, kmActual:parseInt(r.actKm)||null, vehicleType:r.vtype||null };
      }
    });
    localStorage.setItem('fleetScheduleConfig', JSON.stringify(cfg));
    try {
      await axios.post(`${API_BASE_URL}/api/schedule/bulk`, { configs: cfg });
      setStatus('All schedule changes saved and applied to Dashboard.');
    } catch { setStatus('Saved to local storage (backend sync failed).'); }
    setTimeout(()=>setStatus(''), 3000);
  };

  const clearAll = () => {
    if (!window.confirm('Clear ALL schedules for all vehicles?')) return;
    setRows(prev => prev.map(r => ({ vehicle:r.vehicle, interval:'', ltrs:'', kml:'', expKm:'', actKm:'', vtype:'' })));
    localStorage.removeItem('fleetScheduleConfig');
  };

  const clearRow = (v) => setRows(prev => prev.map(r => r.vehicle===v ? { vehicle:v, interval:'', ltrs:'', kml:'', expKm:'', actKm:'', vtype:'' } : r));

  const filtered = rows.filter(r => r.vehicle.toLowerCase().includes(search.toLowerCase()));

  const cellInput = (v, field, val, placeholder) => (
    <input value={val} placeholder={placeholder||''} type="number"
      style={{ width:72, padding:'5px 6px', border:'1px solid #ccc', borderRadius:3, fontSize:12, textAlign:'center', fontFamily:'Arial,sans-serif', color:'#000' }}
      onChange={e=>change(v, field, e.target.value)} />
  );

  return (
    <div>
      <div style={{ ...S.amber, marginBottom:14 }}>
        Set fill interval, litres schedule, and mileage (KM/Fill + KM/L) for all vehicles. Changes apply to the Dashboard immediately.
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:14, alignItems:'center', flexWrap:'wrap' }}>
        <input style={{ ...S.input, width:220 }} placeholder="Search vehicle..." value={search} onChange={e=>setSearch(e.target.value)} />
        <span style={{ fontSize:12, color:'#666' }}>{filtered.length} vehicles</span>
        <div style={{ marginLeft:'auto', display:'flex', gap:8, flexWrap:'wrap' }}>
          <button style={S.btnYellow} onClick={saveAll}>Save All Schedule Changes</button>
          <button style={{ ...S.btnWhite, color:'#c00', border:'1.5px solid #c00' }} onClick={clearAll}>Clear All</button>
        </div>
      </div>

      {status && <div style={{ ...S.success, marginBottom:12 }}>{status}</div>}

      <div style={S.tableWrap}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
          <thead>
            <tr>
              {['Vehicle','Type','Fill Interval (days)','Litres/Fill','KM per Litre','Expected KM','Actual KM','Action'].map(h=>(
                <th key={h} style={{ ...S.th, padding:'10px 8px' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((r,i) => (
              <tr key={r.vehicle} style={{ background:i%2===0?'#fff':'#fafafa' }}>
                <td style={{ ...S.td, textAlign:'left', fontFamily:'monospace', fontWeight:700, color:'#000', paddingLeft:10, whiteSpace:'nowrap' }}>{r.vehicle}</td>
                <td style={S.td}>
                  <select value={r.vtype} onChange={e=>change(r.vehicle,'vtype',e.target.value)}
                    style={{ fontSize:12, border:'1px solid #ccc', borderRadius:3, padding:'4px 6px', background:'#fff', color:'#000' }}>
                    {VTYPES.map(t=><option key={t}>{t}</option>)}
                  </select>
                </td>
                <td style={S.td}>{cellInput(r.vehicle,'interval',r.interval,'days')}</td>
                <td style={S.td}>{cellInput(r.vehicle,'ltrs',r.ltrs,'L')}</td>
                <td style={S.td}>{cellInput(r.vehicle,'kml',r.kml,'km/L')}</td>
                <td style={S.td}>{cellInput(r.vehicle,'expKm',r.expKm,'km')}</td>
                <td style={S.td}>{cellInput(r.vehicle,'actKm',r.actKm,'km')}</td>
                <td style={S.td}>
                  <button style={{ background:'transparent', border:'1px solid #c00', color:'#c00', padding:'3px 8px', borderRadius:3, cursor:'pointer', fontSize:11 }}
                    onClick={()=>clearRow(r.vehicle)}>Clear</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display:'flex', gap:10, marginTop:16 }}>
        <button style={S.btnYellow} onClick={saveAll}>Save All Schedule Changes</button>
        <button style={{ ...S.btnWhite, color:'#c00', border:'1.5px solid #c00' }} onClick={clearAll}>Clear All Schedules</button>
      </div>
    </div>
  );
}

// EMPLOYEES
function Employees({ S, isMobile }) {
  const [employees, setEmployees] = useState([]);
  const [passwords, setPasswords] = useState({});
  const [newName,   setNewName]   = useState('');
  const [newPass,   setNewPass]   = useState('');
  const [search,    setSearch]    = useState('');
  const [savingId,  setSavingId]  = useState(null);

  useEffect(() => { fetchEmployees(); }, []);

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/employees`);
      const data = res.data?.data || res.data || [];
      setEmployees(data);
      const pw = {};
      data.forEach(e => { if (e.password) pw[e.name] = e.password; });
      const local = JSON.parse(localStorage.getItem('fleetEmployeePasswords')||'{}');
      Object.assign(pw, local);
      setPasswords(pw);
    } catch {
      const local = JSON.parse(localStorage.getItem('fleetEmployeePasswords')||'{}');
      const localEmps = JSON.parse(localStorage.getItem('fleetManualEmployees')||'[]');
      setEmployees(localEmps.map(n => ({ name:n, _local:true })));
      setPasswords(local);
    }
  };

  const addEmployee = async () => {
    const n = newName.trim().toUpperCase();
    if (!n) return;
    try {
      await axios.post(`${API_BASE_URL}/api/employees`, { name:n, password:newPass.trim() });
    } catch {}
    const emps = JSON.parse(localStorage.getItem('fleetManualEmployees')||'[]');
    if (!emps.includes(n)) { emps.push(n); localStorage.setItem('fleetManualEmployees', JSON.stringify(emps)); }
    if (newPass) {
      const pw = JSON.parse(localStorage.getItem('fleetEmployeePasswords')||'{}');
      pw[n] = newPass.trim();
      localStorage.setItem('fleetEmployeePasswords', JSON.stringify(pw));
    }
    setNewName(''); setNewPass(''); fetchEmployees();
  };

  const deleteEmployee = async (name) => {
    if (!window.confirm(`Remove employee "${name}"?`)) return;
    try { await axios.delete(`${API_BASE_URL}/api/employees/${encodeURIComponent(name)}`); } catch {}
    const emps = JSON.parse(localStorage.getItem('fleetManualEmployees')||'[]');
    localStorage.setItem('fleetManualEmployees', JSON.stringify(emps.filter(e=>e!==name)));
    const pw = JSON.parse(localStorage.getItem('fleetEmployeePasswords')||'{}');
    delete pw[name]; localStorage.setItem('fleetEmployeePasswords', JSON.stringify(pw));
    fetchEmployees();
  };

  const savePassword = async (name) => {
    setSavingId(name);
    const pw = passwords[name] || '';
    try { await axios.put(`${API_BASE_URL}/api/employees/${encodeURIComponent(name)}`, { password:pw }); } catch {}
    const local = JSON.parse(localStorage.getItem('fleetEmployeePasswords')||'{}');
    if (pw) local[name] = pw; else delete local[name];
    localStorage.setItem('fleetEmployeePasswords', JSON.stringify(local));
    setSavingId(null);
  };

  const filtered = employees.filter(e => (e.name||'').toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ maxWidth:700 }}>
      <div style={S.card}>
        <div style={S.cardTitle}>Employee Login</div>
        <div style={S.info}>
          Employee password: <span style={S.code}>{EMP_PASS}</span>
          <div style={{ marginTop:6, fontSize:12 }}>Employees select their vehicle and enter this password to log in.</div>
        </div>
        <div style={S.amber}>
          Admin password can be changed by editing <span style={S.code}>const ADMIN_PASS</span> in the source file.
          Current admin password: <span style={S.code}>{ADMIN_PASS}</span>
        </div>
      </div>

      <div style={S.card}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12, flexWrap:'wrap', gap:8 }}>
          <div style={S.cardTitle}>
            Employees &nbsp;
            <span style={{ background:'#f5f5f5', color:'#000', border:'1px solid #ccc', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:600 }}>
              {employees.length}
            </span>
          </div>
          <input style={{ ...S.input, width:180 }} placeholder="Search..." value={search} onChange={e=>setSearch(e.target.value)} />
        </div>

        <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
          <input style={{ ...S.input, flex:1, minWidth:140 }} placeholder="Employee name..."
            value={newName} onChange={e=>setNewName(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&addEmployee()} />
          <input style={{ ...S.input, width:130 }} placeholder="Password..."
            value={newPass} onChange={e=>setNewPass(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&addEmployee()} />
          <button style={S.btnYellow} onClick={addEmployee}>Add</button>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {filtered.length === 0 ? (
            <div style={{ color:'#aaa', fontSize:13, padding:12 }}>No employees found. Add employees above.</div>
          ) : filtered.map((emp, i) => {
            const hasPw = !!(passwords[emp.name]);
            return (
              <div key={emp.name} style={{ border:'1.5px solid #000', borderRadius:3, overflow:'hidden' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 12px' }}>
                  <div style={{ width:30, height:30, borderRadius:'50%', background:'#f5f5f5', border:'1.5px solid #000', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:'#000', flexShrink:0 }}>{i+1}</div>
                  <div style={{ flex:1, fontWeight:'bold', fontSize:13 }}>{emp.name}</div>
                  <span style={{ fontSize:11, padding:'2px 10px', borderRadius:3, fontWeight:'bold', background:hasPw?'#f0fff4':'#fffde7', color:'#000', border:'1px solid #000' }}>
                    {hasPw ? 'Password Set' : 'No Password'}
                  </span>
                  <button style={{ background:'transparent', border:'1px solid #c00', color:'#c00', padding:'3px 8px', borderRadius:3, cursor:'pointer', fontSize:12 }}
                    onClick={()=>deleteEmployee(emp.name)}>x</button>
                </div>
                <div style={{ display:'flex', gap:8, padding:'0 12px 10px 52px' }}>
                  <input style={{ ...S.input, flex:1 }} placeholder="Set password..."
                    value={passwords[emp.name]||''}
                    onChange={e=>setPasswords(p=>({...p,[emp.name]:e.target.value}))}
                    onKeyDown={e=>e.key==='Enter'&&savePassword(emp.name)} />
                  <button style={{ ...S.btnYellow, padding:'6px 14px', fontSize:12 }}
                    onClick={()=>savePassword(emp.name)} disabled={savingId===emp.name}>
                    {savingId===emp.name?'Saving...':'Save'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ESCALATIONS
const TAG_OPTIONS = ['Fuel Issue','Late Arrival','Vehicle Damage','Route Deviation','Misconduct','Breakdown','Customer Complaint','Other'];

function Escalations({ S, isMobile }) {
  const [escalations, setEscalations] = useState([]);
  const [vFilter,     setVFilter]     = useState('');
  const [sFilter,     setSFilter]     = useState('');
  const [showForm,    setShowForm]    = useState(false);
  const [form,        setForm]        = useState({ vehicle:'', date:new Date().toISOString().split('T')[0], desc:'', tags:[] });
  const [formMsg,     setFormMsg]     = useState({ type:'', text:'' });

  useEffect(() => { fetchEscalations(); }, []);

  const fetchEscalations = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/escalations`);
      setEscalations(res.data?.data || res.data || []);
    } catch {
      setEscalations(JSON.parse(localStorage.getItem('fleetEscalations')||'[]'));
    }
  };

  const submitEsc = async (e) => {
    e.preventDefault();
    if (!form.vehicle.trim() || !form.desc.trim()) { setFormMsg({type:'error',text:'Vehicle and description required.'}); return; }
    try {
      await axios.post(`${API_BASE_URL}/api/escalations`, { ...form, status:'open', id:Date.now() });
      setForm({ vehicle:'', date:new Date().toISOString().split('T')[0], desc:'', tags:[] });
      setFormMsg({type:'success',text:'Escalation submitted.'});
      setTimeout(()=>setFormMsg({type:'',text:''}), 3000);
      fetchEscalations();
    } catch(err) { setFormMsg({type:'error',text:`Failed: ${err.message}`}); }
  };

  const updateStatus = async (id, status) => {
    try { await axios.patch(`${API_BASE_URL}/api/escalations/${id}`, { status }); fetchEscalations(); } catch {}
  };

  const deleteEsc = async (id) => {
    if (!window.confirm('Delete this escalation?')) return;
    try { await axios.delete(`${API_BASE_URL}/api/escalations/${id}`); fetchEscalations(); } catch {}
  };

  const toggleTag = (tag) => setForm(f => ({ ...f, tags: f.tags.includes(tag) ? f.tags.filter(t=>t!==tag) : [...f.tags, tag] }));

  const vehicles   = [...new Set(escalations.map(e=>e.vehicle))].sort();
  const openCount  = escalations.filter(e=>e.status==='open').length;
  const filtered   = escalations.filter(e => (!vFilter||e.vehicle===vFilter) && (!sFilter||e.status===sFilter));

  return (
    <div>
      <div style={{ display:'flex', gap:10, alignItems:'center', marginBottom:14, flexWrap:'wrap' }}>
        <select style={{ ...S.select, width:'auto' }} value={vFilter} onChange={e=>setVFilter(e.target.value)}>
          <option value="">All Vehicles</option>
          {vehicles.map(v=><option key={v}>{v}</option>)}
        </select>
        <select style={{ ...S.select, width:'auto' }} value={sFilter} onChange={e=>setSFilter(e.target.value)}>
          <option value="">All Status</option>
          <option value="open">Open</option>
          <option value="resolved">Resolved</option>
        </select>
        <button style={S.btnBlack} onClick={()=>setShowForm(f=>!f)}>
          {showForm ? 'Cancel' : 'Add Escalation'}
        </button>
        {openCount > 0 && (
          <span style={{ background:'#000', color:'#fff', fontSize:12, fontWeight:700, padding:'3px 10px', borderRadius:3 }}>
            {openCount} Open
          </span>
        )}
      </div>

      {showForm && (
        <div style={{ ...S.card, maxWidth:640, marginBottom:16 }}>
          <div style={S.cardTitle}>New Escalation</div>
          <form onSubmit={submitEsc}>
            <div style={S.grid2}>
              <div>
                <label style={S.lbl}>Vehicle Number *</label>
                <input style={S.input} placeholder="e.g. KA01AE8482" value={form.vehicle}
                  onChange={e=>setForm({...form,vehicle:e.target.value.toUpperCase()})} required />
              </div>
              <div>
                <label style={S.lbl}>Date</label>
                <input style={S.input} type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} />
              </div>
            </div>
            <div style={{ marginBottom:12 }}>
              <label style={S.lbl}>Description *</label>
              <textarea style={{ ...S.input, minHeight:60, resize:'vertical' }} placeholder="Describe the issue..."
                value={form.desc} onChange={e=>setForm({...form,desc:e.target.value})} required />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={S.lbl}>Tags</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                {TAG_OPTIONS.map(t => (
                  <span key={t} onClick={()=>toggleTag(t)}
                    style={{ padding:'4px 10px', borderRadius:3, fontSize:12, cursor:'pointer', userSelect:'none', border:`1.5px solid ${form.tags.includes(t)?'#FFC107':'#ccc'}`, background:form.tags.includes(t)?'#FFC107':'transparent', color:'#000', fontWeight:form.tags.includes(t)?'bold':'normal' }}>
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button style={S.btnYellow} type="submit">Submit</button>
              <button style={S.btnBlack} type="button" onClick={()=>setShowForm(false)}>Cancel</button>
            </div>
          </form>
          {formMsg.text && <div style={formMsg.type==='success'?S.success:S.error}>{formMsg.text}</div>}
        </div>
      )}

      {filtered.length === 0 ? (
        <div style={{ textAlign:'center', color:'#aaa', padding:40, fontSize:13 }}>No escalations found</div>
      ) : filtered.map(e => (
        <div key={e._id||e.id} style={{ border:'1.5px solid #000', borderRadius:3, padding:'12px 16px', marginBottom:10, background:'#fafafa' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', marginBottom:8 }}>
            <span style={{ fontFamily:'monospace', fontWeight:700, color:'#000', fontSize:13 }}>{e.vehicle}</span>
            <span style={{ fontSize:11, color:'#666' }}>{e.date}</span>
            {(e.tags||[]).map(t=>(
              <span key={t} style={{ fontSize:11, background:'#fffde7', border:'1px solid #FFC107', color:'#000', padding:'2px 8px', borderRadius:3 }}>{t}</span>
            ))}
            <span style={{ marginLeft:'auto', fontSize:11, padding:'3px 12px', borderRadius:3, fontWeight:'bold', background:e.status==='resolved'?'#f0fff4':'#fff0f0', color:'#000', border:'1.5px solid #000' }}>
              {e.status==='resolved'?'Resolved':'Open'}
            </span>
          </div>
          <p style={{ fontSize:13, color:'#333', margin:'0 0 10px', lineHeight:1.6 }}>{e.desc||e.description}</p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            {e.status==='open' ? (
              <button style={S.btnYellow} onClick={()=>updateStatus(e._id||e.id,'resolved')}>Mark Resolved</button>
            ) : (
              <button style={S.btnWhite}  onClick={()=>updateStatus(e._id||e.id,'open')}>Reopen</button>
            )}
            <button style={{ ...S.btnWhite, color:'#c00', border:'1.5px solid #c00' }} onClick={()=>deleteEsc(e._id||e.id)}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
}

// VEHICLE PERFORMANCE
function VehiclePerformance({ S, isMobile }) {
  const now = new Date();
  const [vehicle,     setVehicle]    = useState('');
  const [filterMonth, setFMonth]     = useState('');
  const [filterYear,  setFYear]      = useState(String(now.getFullYear()));
  const [acOpen,      setAcOpen]     = useState(false);
  const [acMatches,   setAcMatches]  = useState([]);
  const [allData,     setAllData]    = useState({});
  const [schedConfig, setSchedCfg]   = useState({});

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/fills/all`).then(r=>setAllData(r.data?.data||{})).catch(()=>{});
    axios.get(`${API_BASE_URL}/api/schedule`).then(r=>setSchedCfg(r.data?.data||{})).catch(()=>{});
  }, []);

  const handleVehicleInput = (val) => {
    setVehicle(val);
    const q = val.toLowerCase();
    setAcMatches(q ? VEHICLES.filter(v=>v.toLowerCase().includes(q)) : []);
    setAcOpen(true);
  };

  const allDays = [];
  Object.keys(allData)
    .filter(mk => {
      const [mon, yr] = mk.split('-');
      if (filterYear  && yr  !== filterYear)  return false;
      if (filterMonth && mon !== filterMonth) return false;
      return true;
    })
    .sort((a,b)=>{
      const [ma,ya]=a.split('-'),[mb,yb]=b.split('-');
      return (parseInt(ya)-parseInt(yb))||(MONTHS_SHORT.indexOf(ma)-MONTHS_SHORT.indexOf(mb));
    })
    .forEach(monthKey => {
      const vd = (allData[monthKey]||{})[vehicle] || {};
      Object.keys(vd).sort((a,b)=>{
        const [da,ma]=a.split('-'),[db,mb]=b.split('-');
        return (MONTHS_SHORT.indexOf(ma)-MONTHS_SHORT.indexOf(mb))||(parseInt(da)-parseInt(db));
      }).forEach(dateKey => allDays.push({ monthKey, dateKey, info:vd[dateKey] }));
    });

  const sc = schedConfig[vehicle] || {};
  const expKml = sc.kmPerLitre || null;

  let totalFills=0, totalLitres=0, totalAmount=0;
  allDays.forEach(({info})=>{ totalFills++; totalLitres+=(info.l||0); totalAmount+=(info.a||0); });

  const statCards = [
    { val:totalFills,                       lbl:'Fill Days'   },
    { val:totalLitres.toFixed(1)+'L',       lbl:'Total Litres'},
    { val:'Rs.'+totalAmount.toLocaleString(),lbl:'Total Amount'},
    { val:expKml?expKml+' km/L':'—',        lbl:'Sched KM/L'  },
    { val:expKml?expKml+' km/L':'—',        lbl:'Avg KM/L'    },
    { val:'—',                              lbl:'Total Act KM' },
  ];

  const monthMap = {};
  allDays.forEach(({monthKey,info})=>{
    if (!monthMap[monthKey]) monthMap[monthKey]={ fills:0, litres:0, amount:0, expKm:0 };
    const m=monthMap[monthKey];
    m.fills++; m.litres+=(info.l||0); m.amount+=(info.a||0);
    if (expKml&&info.l) m.expKm += Math.round(expKml*info.l);
  });
  const sortedMonths = Object.keys(monthMap).sort((a,b)=>{
    const [ma,ya]=a.split('-'),[mb,yb]=b.split('-');
    return (parseInt(yb)-parseInt(ya))||(MONTHS_SHORT.indexOf(mb)-MONTHS_SHORT.indexOf(ma));
  });

  const getRating = (avgKmlVal) => {
    if (!avgKmlVal || !expKml) return null;
    const ratio = parseFloat(avgKmlVal) / expKml;
    if (ratio >= 0.95) return 'Good';
    if (ratio >= 0.85) return 'Average';
    return 'Low';
  };

  return (
    <div>
      <div style={{ ...S.card, marginBottom:14 }}>
        <div style={S.cardTitle}>Vehicle Performance Summary</div>
        <div style={{ fontSize:12, color:'#666', marginBottom:14 }}>Select a vehicle to view fill history and month-by-month performance.</div>

        <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
          <div style={{ position:'relative', flex:1, minWidth:220, maxWidth:360 }}>
            <input style={{ ...S.input, paddingRight:28 }} placeholder="Search vehicle number..."
              value={vehicle} onChange={e=>handleVehicleInput(e.target.value)}
              onFocus={()=>handleVehicleInput(vehicle)} onBlur={()=>setTimeout(()=>setAcOpen(false),150)} />
            {vehicle && (
              <span onClick={()=>{setVehicle('');setAcOpen(false);}} style={{ position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',cursor:'pointer',color:'#aaa',fontSize:12 }}>x</span>
            )}
            {acOpen && acMatches.length>0 && (
              <div style={{ position:'absolute',top:'100%',left:0,right:0,zIndex:200,background:'#fff',border:'1.5px solid #000',borderRadius:3,maxHeight:180,overflowY:'auto',boxShadow:'0 4px 12px rgba(0,0,0,.12)',marginTop:2 }}>
                {acMatches.map(v=>(
                  <div key={v} style={{ padding:'7px 12px',fontSize:12,cursor:'pointer',fontFamily:'monospace' }}
                    onMouseDown={()=>{setVehicle(v);setAcOpen(false);}}
                    onMouseEnter={e=>e.target.style.background='#fffde7'} onMouseLeave={e=>e.target.style.background=''}>
                    {v}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ flex:1, minWidth:140, maxWidth:180 }}>
            <select style={{ ...S.select, width:'100%' }} value={filterMonth} onChange={e=>setFMonth(e.target.value)}>
              <option value="">All Months</option>
              {MONTHS_SHORT.map(m=><option key={m}>{m}</option>)}
            </select>
          </div>

          <div style={{ flex:1, minWidth:140, maxWidth:180 }}>
            <select style={{ ...S.select, width:'100%' }} value={filterYear} onChange={e=>setFYear(e.target.value)}>
              <option value="">All Years</option>
              {YEARS.map(y=><option key={y}>{y}</option>)}
            </select>
          </div>

          <button style={S.btnYellow} onClick={()=>{}}>Load Performance</button>
          <button style={S.btnWhite} onClick={()=>{setVehicle('');setFMonth('');setFYear(String(now.getFullYear()));}}>Clear</button>
        </div>
      </div>

      {!vehicle && (
        <div style={{ textAlign:'center', padding:'50px 20px', color:'#aaa' }}>
          <div style={{ fontSize:13 }}>Search and select a vehicle above to view its performance summary.</div>
        </div>
      )}

      {vehicle && (
        <>
          <div style={{ fontFamily:'monospace', fontSize:'1rem', fontWeight:700, color:'#000', marginBottom:14 }}>{vehicle}</div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:12, marginBottom:16 }}>
            {statCards.map(s=>(
              <div key={s.lbl} style={{ background:'#fafafa', border:'1.5px solid #000', borderRadius:3, padding:'12px 10px', textAlign:'center', borderTop:'3px solid #FFC107' }}>
                <div style={{ fontFamily:'monospace', fontSize:'1.05rem', fontWeight:700, color:'#000' }}>{s.val}</div>
                <div style={{ fontSize:10, color:'#666', marginTop:3, textTransform:'uppercase', letterSpacing:'.04em' }}>{s.lbl}</div>
              </div>
            ))}
          </div>

          {/* Fill History Table */}
          <div style={{ ...S.card, padding:0, overflow:'hidden', marginBottom:14 }}>
            <div style={{ padding:'12px 14px', borderBottom:'1px solid #e0e0e0', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
              <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'.07em', color:'#000' }}>Fill History</div>
              <div style={{ fontSize:11, color:'#666' }}>Showing {allDays.length} fill day{allDays.length!==1?'s':''}</div>
            </div>
            <div style={S.tableWrap}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12, minWidth:860 }}>
                <thead>
                  <tr>
                    {['#','Date','Month','Driver','Litres','Amount','Exp KM','Opening KM','Closing KM','Actual KM','KM/L','KM Diff'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allDays.length===0 ? (
                    <tr><td colSpan={12} style={{ ...S.td, color:'#aaa', padding:24, textAlign:'center' }}>No fill records found{(filterMonth||filterYear)?' for selected period':''}</td></tr>
                  ) : [...allDays].reverse().map(({monthKey,dateKey,info},i)=>{
                    const ltrs   = info.l||0;
                    const amt    = info.a||0;
                    const driver = (info.d||'—').trim();
                    const schedKm= expKml&&ltrs ? Math.round(expKml*ltrs) : null;
                    const [mon, yr] = monthKey.split('-');
                    const monFull   = MONTHS_FULL[MONTHS_SHORT.indexOf(mon)]||mon;
                    return (
                      <tr key={`${monthKey}-${dateKey}-${i}`} style={{ background:i%2===0?'#fff':'#fafafa' }}>
                        <td style={{ ...S.td, color:'#aaa', fontSize:10 }}>{i+1}</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>{dateKey}</td>
                        <td style={{ ...S.td, color:'#666' }}>{monFull} {yr}</td>
                        <td style={S.td}>{driver}</td>
                        <td style={{ ...S.td, fontFamily:'monospace', fontWeight:700 }}>{ltrs}L</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>Rs.{amt.toLocaleString()}</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>{schedKm!=null?schedKm+' km':'—'}</td>
                        <td style={S.td}>—</td>
                        <td style={S.td}>—</td>
                        <td style={S.td}>—</td>
                        <td style={S.td}>—</td>
                        <td style={S.td}>—</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Monthly Performance Table */}
          <div style={{ ...S.card, padding:0, overflow:'hidden' }}>
            <div style={{ padding:'12px 14px', borderBottom:'1px solid #e0e0e0', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'.07em', color:'#000' }}>Month-wise Performance</div>
              <div style={{ fontSize:11, color:'#666' }}>{sortedMonths.length} month(s)</div>
            </div>
            <div style={S.tableWrap}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12, minWidth:700 }}>
                <thead>
                  <tr>
                    {['Month','Fill Days','Total Litres','Total Amount','Exp KM','Actual KM','KM/L','KM Diff','Rating'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedMonths.length===0 ? (
                    <tr><td colSpan={9} style={{ ...S.td, color:'#aaa', padding:24, textAlign:'center' }}>No monthly data available</td></tr>
                  ) : sortedMonths.map((mk,idx)=>{
                    const m = monthMap[mk];
                    const [mon,yr] = mk.split('-');
                    const monFull  = MONTHS_FULL[MONTHS_SHORT.indexOf(mon)]||mon;
                    const avgKmlM  = expKml&&m.litres>0 ? (m.litres*expKml/m.fills).toFixed(1) : null;
                    const rating   = getRating(avgKmlM);
                    return (
                      <tr key={mk} style={{ background:idx%2===0?'#fff':'#fafafa' }}>
                        <td style={{ ...S.td, fontWeight:700, textAlign:'left' }}>{monFull} {yr}</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>{m.fills}</td>
                        <td style={{ ...S.td, fontFamily:'monospace', fontWeight:700 }}>{m.litres.toFixed(1)}L</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>Rs.{m.amount.toLocaleString()}</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>{m.expKm>0?m.expKm.toLocaleString()+' km':'—'}</td>
                        <td style={S.td}>—</td>
                        <td style={{ ...S.td, fontFamily:'monospace' }}>{avgKmlM?avgKmlM+' km/L':'—'}</td>
                        <td style={S.td}>—</td>
                        <td style={S.td}>
                          {rating ? (
                            <span style={{ background: rating==='Good'?'#f0fff4':rating==='Average'?'#fffde7':'#fff0f0', color:'#000', border:'1px solid #000', borderRadius:3, padding:'2px 8px', fontSize:11, fontWeight:700 }}>{rating}</span>
                          ) : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}